import PageHead from "@/components/PageHead";
import TestimonialsCarousel from "@/components/TestimonialsCarousel";
import NewsletterPromoBar from "@/components/NewsletterPromoBar";
import HomeHero from "@/components/home/HomeHero";
import HomeTrustBar from "@/components/home/HomeTrustBar";
import HomeManifesto from "@/components/home/HomeManifesto";
import HomeAreas from "@/components/home/HomeAreas";
import HomeInterlocutor from "@/components/home/HomeInterlocutor";
import HomeProcess from "@/components/home/HomeProcess";
import HomeAcompanhamento from "@/components/home/HomeAcompanhamento";
import HomeEspecialidades from "@/components/home/HomeEspecialidades";
import HomeCodigoH from "@/components/home/HomeCodigoH";
import HomeQualidade from "@/components/home/HomeQualidade";
import HomeTransformacoes from "@/components/home/HomeTransformacoes";
import HomeCuidado from "@/components/home/HomeCuidado";
import HomeCtaFinal from "@/components/home/HomeCtaFinal";

/**
 * Homepage composition.
 * Each visual section lives in its own file under /src/components/home/
 * — edit that file to change a specific section without touching this composition.
 */
export default function Home() {
    return (
        <>
            <PageHead
                title="O Homem da Obra | Remodelações · Gestão de Obra · Valorização de Imóveis"
                description="Remodelações, gestão de obra e valorização de imóveis em Lisboa, Cascais, Oeiras, Sintra e distritos de Setúbal e Santarém. Com método, coordenação e responsabilidade."
                canonical="https://ohomemdaobra.pt/"
            />
            <HomeHero />
            <NewsletterPromoBar source="home-hero" />
            <HomeManifesto />
            <HomeAreas />
            <HomeTrustBar />
            <HomeInterlocutor />
            <HomeProcess />
            <HomeAcompanhamento />
            <HomeEspecialidades />
            <HomeCodigoH />
            <HomeQualidade />
            <HomeTransformacoes />
            <TestimonialsCarousel />
            <HomeCuidado />
            <HomeCtaFinal />
        </>
    );
}
